import styled from '@emotion/styled'

// TODO: 与UI 沟通优化下样式
const BaseTable = styled.div`
  .BaseTable {
    flex: 1;
    /* box-shadow: 0 2px 4px 0 #eeeeee; */
    /* background-color: #fff; */
    position: relative;
    box-sizing: border-box;
    font-size: 13px;
    border-radius: 4px;
    color: var(--ow-color-gray-100);
  }

  .BaseTable--disabled {
    opacity: 0.7;
    pointer-events: none;
  }
  .BaseTable--dynamic .BaseTable__row {
    overflow: hidden;
    align-items: stretch;
  }

  // 大表数据列不换行(大表不可能自适应高度)
  .MatrixTable .BaseTable__table-main .BaseTable__row-cell-text {
    /* overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 100%;
    padding: 0.5rem 0; */
    overflow: hidden;
    height: 100%;
    display: flex;
    align-items: center;
    width: 100%;
    flex-wrap: nowrap;
  }

  .BaseTable:not(.MatrixTable):not(.table-self-adaption):not(.BaseTable--dynamic)
    .BaseTable__row-cell-32,
  .BaseTable:not(.MatrixTable):not(.table-self-adaption)
    .BaseTable__row--frozen
    .BaseTable__row-cell-32 {
    overflow: hidden;
    white-space: nowrap;
    height: 100%;
    display: flex;
    align-items: center;
    width: 100%;
  }

  .MatrixTable
    .BaseTable__table:not(.BaseTable__table-frozen-left)
    .BaseTable__row-cell-32 {
    overflow: hidden;
    white-space: nowrap;
    height: 100%;
    display: flex;
    align-items: center;
    width: 100%;
  }

  .MatrixTable
    .BaseTable__table
    .BaseTable__table-frozen-left
    .BaseTable__row-cell-32 {
    overflow: hidden;
    white-space: wrap !important;
    height: 100%;
    display: flex;
    align-items: center;
    width: 100%;
  }
  /* 大表指标列可换行 */
  .MatrixTable .BaseTable__table-frozen-left .BaseTable__row-cell-text {
    overflow: hidden;
    height: 100%;
    display: flex;
    align-items: center;
    width: 100%;
    flex-wrap: wrap;
  }
  .BaseTable:not(.MatrixTable)
    .BaseTable__table:not(.BaseTable__table-frozen-right)
    .BaseTable__row-cell-text {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 4px 0;
    height: 100%;
  }

  .BaseTable:not(.BaseTable--dynamic) .BaseTable__row-cell-selection,
  .BaseTable .BaseTable__row--frozen .BaseTable__row-cell-selection {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .BaseTable__row-cell-selection {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    height: 100%;
    display: flex;
    /* align-items: center;
    justify-content: center; */
  }
  .BaseTable__table {
    background-color: #ffffff;
    position: absolute;
    top: 0;
    display: flex;
    flex-direction: column-reverse;
  }

  .BaseTable__table-main {
    /* outline: 1px solid #dde1e3; */
    border-radius: 4px;
    left: 0;
  }
  .BaseTable__table-main .BaseTable__header-cell:last-child,
  .BaseTable__table-main .BaseTable__row-cell:last-child {
    padding-right: 15px;
  }
  /* .BaseTable__table-main .BaseTable__header-cell:last-child,
  .BaseTable__table-main .BaseTable__row-cell:last-child {
    border-right: 1px solid #dde1e3;
  } */
  .BaseTable__table-main .BaseTable__header {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    /* background-color: #88b8ff; */
  }
  .BaseTable__table-frozen-left .BaseTable__header,
  .BaseTable__table-frozen-left .BaseTable__body,
  .BaseTable__table-frozen-right .BaseTable__header,
  .BaseTable__table-frozen-right .BaseTable__body,
  .BaseTable__operate-table-frozen-right .BaseTable__header,
  .BaseTable__operate-table-frozen-right .BaseTable__body {
    overflow: hidden !important;
  }
  .BaseTable__table-frozen-left {
    box-shadow: 2px 0 0 0 #eeeeee;
    top: 0;
    left: 0;
    border-top-left-radius: 4px;
  }
  /* .BaseTable__table-frozen-left .BaseTable__header-cell:last-child,
  .BaseTable__table-frozen-left .BaseTable__row-cell:last-child {
    border-right: 1px solid #dde1e3;
  } */
  .BaseTable__table-frozen-left .BaseTable__header-row,
  .BaseTable__table-frozen-left .BaseTable__row {
    padding-right: 0 !important;
  }
  /* .BaseTable__table-frozen-left .BaseTable__body {
    overflow-y: auto !important;
  } */
  .BaseTable__table-frozen-right {
    box-shadow: -2px 0 4px 0 #eeeeee;
    top: 0;
    right: 0;
  }
  .BaseTable__table-frozen-right .BaseTable__header-cell:last-child,
  .BaseTable__table-frozen-right .BaseTable__row-cell:last-child {
    padding-right: 15px;
  }
  /* .BaseTable__table-frozen-right .BaseTable__header-cell:last-child,
  .BaseTable__table-frozen-right .BaseTable__row-cell:last-child {
    border-right: 1px solid #dde1e3;
  } */
  .BaseTable__table-frozen-right .BaseTable__header-row,
  .BaseTable__table-frozen-right .BaseTable__row {
    padding-left: 0 !important;
  }
  .BaseTable__table-frozen-right .BaseTable__body {
    overflow-y: auto !important;
  }
  .BaseTable__header {
    border-radius: 4px;
    overflow: hidden !important;
    /* border: solid 1px #eef0f2; */
  }
  .BaseTable .BaseTable__header,
  .BaseTable .BaseTable__body {
    outline: none;
  }
  .BaseTable__header-row,
  .BaseTable__row {
    display: flex;
    align-items: center;
    box-sizing: border-box;
  }
  .BaseTable__header-row {
    font-size: 13px;
    font-weight: bold;
    border-bottom: 1px solid var(--ow-color-neutral-300);
  }
  .BaseTable__row {
    /* background-color: #ffffff; */
    border-bottom: 1px solid var(--ow-color-neutral-300);
  }
  .BaseTable:not(.MatrixTable) .BaseTable__row:hover,
  .BaseTable:not(.MatrixTable) .BaseTable__row--hovered {
    background-color: var(--ow-color-primary-50);
    /* box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.19); */
    .row-operate {
      visibility: visible !important;
    }
  }
  .BaseTable__row--operate-visible {
    .row-operate {
      visibility: visible !important;
    }
  }
  .BaseTable__row:hover .opt-icon {
    display: flex !important;
  }
  .BaseTable__row:hover .code-value {
    display: none !important;
  }
  .BaseTable__row-expanded {
    border-bottom: 1px solid #dde1e3;
  }
  .BaseTable__header-cell {
    min-width: 0;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 24px;
    box-sizing: border-box;
    /* border-bottom: 1px solid var(--ow-color-neutral-300); */
  }
  .BaseTable__row-cell {
    min-width: 0;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 24px;
    box-sizing: border-box;
    /* border-bottom: 1px solid var(--ow-color-neutral-300); */
    /* border-left: 1px solid #dde1e3;
    border-right: 0;
    border-top: 0; */
  }
  .BaseTable__header-cell--align-center,
  .BaseTable__row-cell--align-center {
    justify-content: center;
    text-align: center;
  }
  .BaseTable__header-cell--align-right,
  .BaseTable__row-cell--align-right {
    justify-content: flex-end;
    text-align: right;
  }
  .BaseTable__header-cell {
    position: relative;
    cursor: default;
  }
  .BaseTable__header-cell:hover .BaseTable__column-resizer {
    visibility: visible;
    opacity: 0.5;
  }
  .BaseTable__header-cell:hover .BaseTable__column-resizer:hover {
    opacity: 1;
  }
  .BaseTable__header-cell .BaseTable__sort-indicator {
    /* display: none; */
  }
  .BaseTable__header-cell--sortable {
    gap: 12px;
  }
  .BaseTable__header-cell--sortable:hover {
    /* background-color: #f3f3f3; */
    cursor: pointer;
  }
  .BaseTable__header-cell--sortable:not(.BaseTable__header-cell--sorting):hover
    .BaseTable__sort-indicator {
    display: block;
    color: #888888;
  }
  .BaseTable__header-cell--sorting .BaseTable__sort-indicator,
  .BaseTable__header-cell--sorting:hover .BaseTable__sort-indicator {
    display: block;
  }
  .BaseTable__header-cell--resizing .BaseTable__column-resizer {
    visibility: visible;
    opacity: 1;
  }
  .BaseTable__header-cell--resizing .BaseTable__column-resizer::after {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    overflow: hidden;
    content: '';
    left: -9999px;
  }
  .BaseTable__header-cell-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
  }
  .BaseTable__header-cell-text {
    /* width: 100%; */
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .BaseTable__header-row--resizing .BaseTable__header-cell {
    background-color: transparent;
    cursor: col-resize;
  }
  .BaseTable__header-row--resizing
    .BaseTable__header-cell:not(.BaseTable__header-cell--sorting)
    .BaseTable__sort-indicator {
    display: none;
  }
  .BaseTable__header-row--resizing
    .BaseTable__header-cell:not(.BaseTable__header-cell--resizing)
    .BaseTable__column-resizer {
    visibility: hidden;
  }
  .BaseTable__column-resizer {
    width: 3px;
    visibility: hidden;
    background-color: #cccccc;
  }
  .BaseTable__column-resizer:hover {
    visibility: visible;
    opacity: 1;
  }
  .BaseTable__footer {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    /* background-color: #ffffff; */
  }
  .BaseTable__resizing-line {
    cursor: col-resize;
    position: absolute;
    top: 0;
    background-color: #cccccc;
    width: 3px;
    transform: translateX(-100%);
  }
  .BaseTable__empty-layer {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    overflow: hidden;
  }
  .BaseTable__overlay {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    overflow: hidden;
    pointer-events: none;
  }
  .BaseTable__overlay > * {
    pointer-events: auto;
  }
  // 操作表格
  .BaseTable__operate-table-frozen-right {
    background-color: transparent;
    top: 0;
    right: 0;
    .BaseTable__header {
      border: none;
    }
    .BaseTable__header-row {
      background-color: transparent;
      border-bottom: transparent;
    }
    .BaseTable__row {
      background-color: transparent;
      border-bottom: transparent;
    }
    .BaseTable__row-cell {
      border-bottom: 0;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
    }

    .BaseTable__row-cell-32 {
      border-bottom: 0;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
    }
    .BaseTable__row--hovered {
      box-shadow: none;
    }
  }
  .BaseTable:not(.MatrixTable)
    .BaseTable__operate-table-frozen-right
    .BaseTable__row-cell-text {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  }
  .BaseTable__operate-table-frozen-right .BaseTable__header-cell:last-child,
  .BaseTable__operate-table-frozen-right .BaseTable__row-cell:last-child {
    padding-right: 15px;
  }
  /* .BaseTable__operate-table-frozen-right .BaseTable__header-cell:last-child,
  .BaseTable__operate-table-frozen-right .BaseTable__row-cell:last-child {
    border-right: 1px solid #dde1e3;
  } */
  .BaseTable__operate-table-frozen-right .BaseTable__header-row,
  .BaseTable__operate-table-frozen-right .BaseTable__row {
    padding-left: 0 !important;
  }
  .BaseTable__operate-table-frozen-right .BaseTable__body {
    overflow-y: auto !important;
  }
  .BaseTable__row-cell-selection {
    width: unset;
    display: flex;
    align-items: start;
    padding-top: 2px;
  }
  .sticky-row {
    .BaseTable__row-cell:not(:first-child) {
      background: var(--ow-color-neutral-300);
    }
  }

  .BaseTable .BaseTable__table-frozen-right {
    box-shadow: -2px 0 0 0 #eeeeee;
    top: 0;
    right: 0;
  }
  /* .BaseTable__operate-table-frozen-right .BaseTable__body {
    overflow-y: auto !important;
    overflow-x: hidden !important;
  } */
  .BaseTable ::-webkit-scrollbar {
    width: 0.6rem;
    height: 0.6rem;
  }
`

export default BaseTable
